// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Button, Text } from '@mantine/core';
import { IconQuestionCircle } from '@tabler/icons';
import { RoutingS } from '../../../Service/RoutingS';
import BookitupAlert from '../../../Atoms/BookitupAlert';

const ARTICLE_LINK = 'https://bookitup.de/hilfe/wie-kann-ich-das-ressourcen-modul-buchen/';

const AddonManagementPane = () => (
  <BookitupAlert mt="md" icon={<IconQuestionCircle />} title="Wie kann ich das Ressourcen-Modul buchen?">
    <Text>In unserem Hilfeartikel erklären wir, wie Du das Ressourcen Modul dazu buchen kannst.</Text>
    <Button size="xs" mt="md" onClick={() => RoutingS.openInNewTab(ARTICLE_LINK)}>
      Hilfeartikel aufrufen
    </Button>
  </BookitupAlert>
);

export default AddonManagementPane;
